<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Pirkumu grozs</div>
    </div>
  </div>

  <cart-steps step="2"></cart-steps>
  <div class="ui attached segment">

    <div class="ui form">
      <div class="grouped fields">
        <!-- cart will be rested and vue will generate error trying to calculate missingInAccount. as solution we check if cart.details are defined -->
        <div v-if="cart.details && missingInAccount>=0">
           Apliecinu, ka vēlos veikt pasūtījumu par <b>{{(cart.details.total_price_with_bail_and_vat - cart.details.final_discount_vat).toFixed(2)}}</b> &euro;, kas tiks atskaitīts no mana konta
        </div>
        <div v-else>
           Kontā pietrūkst <b>{{missingInAccount}} &euro;.</b> Maksāšu ar:
        <div v-for="item in paymentMethods" class="field" v-if="cart.details.cash_allowed || item.id != 3 && !cart.details.cash_allowed">
          <div class="ui radio checkbox" v-if="((cart.delivery_type_id != 1 && item.id != 5 && cart.delivery_type_id != 1 && item.id != 3) || cart.delivery_type_id == 1) && ((item.id == 5 && user.pay_later == 1) || (item.id != 5 && user.pay_later == 0) || (item.id != 5 && user.pay_later == 1))">
			<span v-if="item.id == 5 && overCreditLimit < 0">
				<input type="radio" name="payment_type" :checked="false" disabled />
				<label>
					<b>{{item.name}}</b><span style="color: red;">&nbsp;Jūsu pasūtījums pārsniedz kredītlimitu {{user.credit_limit}} EUR. Lūdzu papildiniet kontu vismaz par EUR {{overCreditLimit.toFixed(2)}}.</span>
					<a v-if="item.url" :href="item.url" target="blank">({{item.urlText}})</a>
				</label>
			</span>
			<span v-else>
				<input :id="item.id" type="radio" name="payment_type" :checked="item.id == cart.payment_type" number @change="updatePaymentMethod(item.id)" />
				<label :for="item.id">
					<b>{{item.name}}</b>
					<span class="ms-small-txt" v-if="item.charge > 0">(pasūtījuma apstrādes maksa {{item.charge}} EUR)</span>
					<a v-if="item.url" :href="item.url" target="blank">({{item.urlText}})</a>
				</label>
			</span>
          </div>
        </div>
        </div>
      </div>
      <div class="inline fields" v-if="cart.payment_type != 3 && cart.payment_type !=  5 && cart.payment_type != 2">
        <div>Papildus šim pasūtījumam vēlos iemaksāt avansu &nbsp; </div>
        <div class="field">
          <input type="number" step="1" :value="cart.top_up" number @change="updateTopUpAmount($event.target.value)"> &euro;
        </div>

      </div>
      <div class="ui checkbox" v-if="user.bonus > 0 && cart.details && cart.details.total_price_with_bail_and_vat - cart.details.final_discount_vat > 0 && cart.details.no_water_goods_price_vat > 0">
        <input id="use_bio" type="checkbox" :checked="cart.use_bonus" value="1" number @change="updateBonusStatus($event.target.checked)" >
        <label for="use_bio" style="color:#21BA45">
			Vēlos izmantot bonusu BIO produktu iegādei. Mans kopējais uzkrājums <b>{{user.bonus}} &euro;</b><br />
			<span style="font-size: 0.8em;">*Līdz 30% no kopējās produktu summas.</span>
		</label>
      </div>

      <div>
        <br>
      <div class="ui buttons">
      <button class="ui button" @click="$router.push({name:'cart'})" :class="{disabled: showLoading}">Atpakaļ</button>
      <div class="or" data-text="vai"></div>
      <button class="ui custom_brown button" @click="processCart" :class="{loading: showLoading, disabled: missingInAccount<0 && cart.payment_type == 2}">Apmaksāt</button>
      </div>
    </div>

    </div>

  </div>
  
  <div id="cart_total_price_with_bail_and_vat" style="width: 0; height: 0; visibility: hidden;">{{cart.details.total_price_with_bail_and_vat}}</div>
</div>
</template>

<script>
import CartSteps from './CartSteps'

export default {
  components: {
    CartSteps
  },

  data() {
    return {
      method: 6,
      amount: '',
      showLoading: false, //will use local state so that user still sees loading icon while windows method is opening new url
      isActive: false,
      missingInAccount: false, //cannot use 0 as this is evaulated by activated
      paymentMethods: [{
        id: 6,
        name: 'Bankas maksājumu karti (VISA/Mastercard)',
        charge: '0.30'
      }, {
        id: 7,
        name: 'SEB internetbanku',
        charge: '0.50'
      }, {
        id: 8,
        name: 'Citadele internetbanku',
        charge: '0.50'
      }, {
        id: 9,
        name: 'Luminor internetbanku',
        charge: '0.50'
      }, {
        id: 10,
        name: 'Swedbank internetbanku',
        charge: '0.50'
      }, {
        id: 11,
        name: 'Revolut internetbanku',
        charge: '0.50'
      }, {
        id: 3,
        name: 'Skaidrā naudā saņemot preci',
        charge: 0,
      }, {
        id: 5,
        name: 'Pēcapmaksu',
        charge: 0,
      }]

    }

  },

  computed: {
    user() {
      return this.$store.state.userStore.user
    },
    storeStatus() {
      return this.$store.state.userStore.status
    },
    cart() {
      return this.$store.state.cartStore.activeCart
    },
	overCreditLimit() {
		var amount = 0;
		var amountToCheck = 0;
		if (this.cart.details.no_water_goods_price_vat > 0) {
			amountToCheck = parseFloat(this.user.credit_limit) + parseFloat(this.user.balance) - parseFloat(this.cart.details.total_price_with_bail_and_vat - this.cart.details.final_discount_vat);
		} else {
			amountToCheck = parseFloat(this.user.credit_limit) + parseFloat(this.user.balance);
		}
		amount = (amountToCheck < 0) ? amountToCheck : amount;
		return amount;
	}
  },

  created () {
    window.addEventListener('onpopstate', function () { location.reload(); });
  },
  unmounted () {
    window.removeEventListener('onpopstate', function () { location.reload(); });
  },
  activated: function() {
    //set default values
    this.showLoading = false;
    //preload user data to refresh balance
    this.$store.dispatch('loadUser');
    //preload cart

    this.$store.dispatch('loadActiveCart').then((response) => {
          //calculate amount that is missing in account
          this.updateMissingInAccount();
		  
          //if customer will pay from account and payment type is different then update cart
          if (this.amountToCheck < 0 || (response.data.data.payment_type != 2 && this.missingInAccount && this.missingInAccount >= 0)) {
            this.updatePaymentMethod(2);
          }
		  
          //info for fbook
          var ids = [];
          var numItems = 0

          for (var key in this.cart.items) {
            ids.push(this.cart.items[key].good_id)
            numItems = numItems + Number(this.cart.items[key].order)
          }

          fbq('track', 'AddPaymentInfo', {
            value: this.cart.details.total_price_with_bail_and_vat - this.cart.details.final_discount_vat,
            currency: 'EUR',
            content_ids:ids,
            num_items:numItems
          });
		  
    }).catch((error) => {
      console.error('Cart was not loaded: ' + error)

    });
  },
  methods: {
    //seting this only once when we onload payment page so that amount is not changed when cart is reset and user is waiting while he will be redirected to payment method
    updateMissingInAccount() {
      // `this` points to the vm instance
      var amount = this.$store.state.userStore.user.balance;

      if(this.$store.state.cartStore.activeCart.details){
        amount = amount - this.$store.state.cartStore.activeCart.details.total_price_with_bail_and_vat - this.$store.state.cartStore.activeCart.details.final_discount_vat;

        amount = amount.toFixed(2);
      }

      this.missingInAccount = amount;
    },
    updatePaymentMethod: function(paymentType){
      var updatedCart = JSON.parse(JSON.stringify(this.cart)); //copy object
      updatedCart.payment_type = paymentType;
      //below logic not required as this is done on backend
      //if(paymentType == 3 || paymentType ==  5 || paymentType == 2) updatedCart.top_up = 0 // reset depending on payment type

      this.$store.dispatch('updateActiveCart', updatedCart);
    },
    updateBonusStatus(value){
      var updatedCart = JSON.parse(JSON.stringify(this.cart)); //copy object
      updatedCart.use_bonus = (value) ? 1 : 0;
      this.$store.dispatch('updateActiveCart', updatedCart);
    },
    updateTopUpAmount(amount){
      var updatedCart = JSON.parse(JSON.stringify(this.cart)); //copy object
      updatedCart.top_up = amount
      this.$store.dispatch('updateActiveCart', updatedCart);
    },
    processCart(){
      this.showLoading = true;

        //info for fbook
        var ids = [];
        var numItems = 0

        for (var key in this.cart.items) {

          ids.push(this.cart.items[key].good_id)
          numItems = numItems + Number(this.cart.items[key].order)

        }


        fbq('track', 'Purchase', {
          content_ids: ids,
          content_type: 'product',
          value:this.cart.details.total_price_with_bail_and_vat - this.cart.details.final_discount_vat,
          currency: 'EUR'
        });


      this.$store.dispatch('processCart', this.cart).then((response) => {
            //open payment link
            if(response.data.payment_url != ''){
                window.location.href = response.data.payment_url;
            } else {
                this.$store.dispatch('loadUser'); //reload user to refresh balance
                //go to confirmation page
                this.$router.push({
                    name: 'cart-confirmation-orderid',
                    params:{orderid: response.data.order.id}
                });
            }

      }).catch((error) => {
        console.error('Cart was not processed due to error: ' + error)
        this.showLoading = false;
      });;
    }
  }
}
</script>



// WEBPACK FOOTER //
// CartPaymentPage.vue?dae290cc